import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useState, useEffect } from 'react';
import { PropertyRule } from '@/hooks/usePropertyRules';

interface PropertyRuleFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (title: string) => void;
  rule?: PropertyRule | null;
}

const PropertyRuleFormModal = ({
  isOpen,
  onClose,
  onSave,
  rule,
}: PropertyRuleFormModalProps) => {
  const [title, setTitle] = useState('');

  useEffect(() => {
    if (rule) {
      setTitle(rule.title);
    } else {
      setTitle('');
    }
  }, [rule, isOpen]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (title.trim()) {
      onSave(title.trim());
      setTitle('');
    }
  };

  const handleClose = () => {
    setTitle('');
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>{rule ? 'Editar Regla' : 'Nueva Regla'}</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="title">Título *</Label>
            <Input
              id="title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Ej: Check-in: 3:00 PM"
              required
              autoFocus
            />
          </div>

          <div className="flex justify-end gap-3">
            <Button type="button" variant="outline" onClick={handleClose}>
              Cancelar
            </Button>
            <Button type="submit" disabled={!title.trim()}>
              {rule ? 'Actualizar' : 'Crear'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default PropertyRuleFormModal;
